import { search } from 'common/window_location';

/**
 * Storyteller 'print' mode is signified by the presence of a url parameter 'print' with value 'true'
 * as seen in stories_helper.rb should_load_print_styles?
 * */
export function inPrintMode() {
  const urlParams = new URLSearchParams(search());
  // this is case sensitive to match the ruby check in should_load_print_styles?
  return urlParams.get('print') === 'true';
}
